
import React from 'react';

interface GameCardProps {
  title: string;
  description: string;
  imageUrl: string;
  link: string;
  status: string;
  statusColor: string;
}

const GameCard: React.FC<GameCardProps> = ({ title, description, imageUrl, link, status, statusColor }) => {
  return (
    <div className="bg-white rounded-2xl overflow-hidden shadow-lg transform hover:-translate-y-2 transition-transform duration-300 flex flex-col">
      <div className="relative">
        <img className="w-full h-56 object-cover" src={imageUrl} alt={title} />
        <div className={`absolute top-4 right-4 text-white font-bold font-heading py-1 px-3 rounded-full text-sm ${statusColor}`}>
          {status}
        </div>
      </div>
      <div className="p-6 flex flex-col flex-grow">
        <h3 className="font-heading text-2xl font-bold text-jskool-dark mb-2">{title}</h3>
        <p className="text-jskool-dark/70 mb-4 flex-grow">{description}</p>
        <a href={link} className="mt-auto bg-jskool-blue hover:bg-blue-700 text-white font-bold font-heading py-2 px-6 rounded-lg self-start transition-opacity duration-300">
          Learn More
        </a>
      </div>
    </div>
  );
};

const GamesPage: React.FC = () => {
  return (
    <section className="flex-grow py-20 bg-jskool-cream">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-heading font-extrabold text-jskool-dark">JSkool Online Games</h1>
          <p className="mt-4 text-lg text-jskool-dark/70 max-w-3xl mx-auto">
            Engaging games designed to make learning Jain principles fun and interactive for all ages.
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10 max-w-5xl mx-auto">
          <GameCard 
            title="Moksha Patham" 
            description="The ancient game of liberation. Climb the ladders of virtue and avoid the snakes of vice on your path to enlightenment."
            imageUrl="https://images.unsplash.com/photo-1610890714952-537b03789852?q=80&w=600&auto=format&fit=crop"
            link="/mokshapatam"
            status="Coming Soon"
            statusColor="bg-jskool-yellow text-jskool-dark"
          />
           <div className="border-4 border-dashed border-gray-300 rounded-2xl flex flex-col items-center justify-center p-6 text-center text-gray-500 h-full min-h-[400px]">
             <svg className="w-16 h-16 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
             <h3 className="font-heading text-2xl font-bold">New Game in Development</h3>
             <p className="mt-2">More exciting learning adventures are on the way!</p>
           </div>
        </div>
      </div>
    </section>
  );
};

export default GamesPage;